import { ResultsView } from './results-view'
import { SectionsView } from './sections-view'
import style from './workout-screen.module.scss'
import { useFilterContext } from '../../context/filter-context'
import React from 'react'
import { FilterSidebar } from 'src/component/workout-filter/filter-sidebar'
import { MobileFilters } from 'src/component/workout-filter/mobile-filters'

export const WorkoutListScreen = (): React.ReactElement => {
  const { activeFilterCount, hideCompleted } = useFilterContext()

  // The Completed Workouts toggle is a visibility filter in its own right: hiding completed workouts
  // only makes sense against a flat list, so toggling it (even with no category filters) flips the
  // page from the curated sections to the RESULTS grid, which applies `hideCompleted` to its query.
  const showResults = activeFilterCount > 0 || hideCompleted

  return (
    <div className={style.workoutsLayout}>
      <FilterSidebar />
      <div className={style.workoutsMain}>
        <MobileFilters />
        {showResults ? <ResultsView /> : <SectionsView />}
      </div>
    </div>
  )
}
